import React from "react";

export default function ScoreboardElement({ rank, highscore }) {
  const { playername, score, mapsize, difficulty } = highscore;

  return (
    <tr>
      <td>{rank}</td>
      <td>{playername}</td>
      <td>{score}</td>
      <td>{capitalizeFirstLetter(mapsize)}</td>
      <td>{capitalizeFirstLetter(difficulty)}</td>
    </tr>
  );
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
